import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { Container, Dialog, Drawer, useMediaQuery } from "@material-ui/core";
import Colors from "../../../common/materials/colors";
import HeaderMenu from "./HeaderMenu";
import { useHistory } from "react-router-dom";
import {
  StyledLogoBackground,
  StyledLeftAlignedContainer,
  StyledRightAlignedContainer,
  HiddenButton,
} from "../../../pages/LandingPage/Header/StyledComponent";
import Logo from "../../../pages/LandingPage/Static/Icons/Logo";
import LanguageSelector from "../../../pages/LandingPage/Header/LanguageSelector";
import NotificationToggle from "../../../common/elements/notification/NotificationToggle";
import styled from "styled-components";
import { CommonHorizontalPadding } from "../../../pages/LandingPage/StyledComponents";
import ProfileMenu from "./ProfileMenu";
import { Box, IconButton, useTheme } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { MenuData, SubDoaminMenuData } from "./MenuData";
import MobileMenus from "./MobileMenus";
import { DialogProvider } from "../../../common/elements/Dialog/Dialog";
import auctions from "../../../services/ProductsApiService";
//Working on header of Mobile -Inner Header
const HeaderContainer = styled(CommonHorizontalPadding)`
  position: sticky;
  top: 0;
  z-index: 1001;
  background-color: ${Colors.white};
  display: flex;
  align-items: center;
  -webkit-box-shadow: 0 3px 5px #cccccc90;
  -moz-box-shadow: 0 3px 5px #cccccc90;
  box-shadow: 0 3px 5px #cccccc90;
`;
const StyledLogo = styled.img`
  width: 45%;
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    width: 40px;
    display: flex;
  }
  ${(props) => props.theme.breakpoints.between("md", "xl")} {
    width: 45%;
  }
`;
export const WebHeader = ({ isZipangDomain, isGlowstar }: any) => {
  const history = useHistory();
  let subdomainType = localStorage.getItem("subDomain");
  const [auctionList, setAuctionList] = useState([]);
  useEffect(() => {

    console.log("New Header Fetch Auction", window.location.pathname);
    const queryParams = new URLSearchParams(window.location.search);
  if(queryParams.get("source") === 'admin'){ 
    //Admin Preview Link hitted
    return;
  }
    const fetchAuctions = async () => {
      try {
        const auctionlist = await auctions();
        if (!auctionlist?.results || auctionlist.results.length === 0) {
          return;
        }
        setAuctionList(auctionlist.results);
      } catch (error) {
        console.error("Failed to fetch auction list", error);
      }
    };

    fetchAuctions();
  }, []);

  return (
    <DialogProvider>
      <HeaderContainer style={{ position: "fixed" }}>
        <Container>
          <Grid container alignItems="center">
            <Grid xs={1} item>
              <StyledLogoBackground
                onClick={() => {
                  if (isZipangDomain) {
                    // history.push("/zipang");
                    history.push({
                      pathname: "/zipang",
                      search: "?islandingpage=true",
                    });
                  } else {
                    history.push("/");
                  }
                }}
                style={{ cursor: "pointer" }} // ensures pointer cursor
              >
                {isZipangDomain ? (
                  <StyledLogo
                    src="/images/zipangLogo.png"
                    alt="zipang image #1"
                  />
                ) : isGlowstar ? (
                  <StyledLogo
                    src="https://ds29nc3ljdjce.cloudfront.net/icon.png"
                    alt="glowstart url"
                  />
                ) : (
                  <Logo />
                )}
              </StyledLogoBackground>
            </Grid>
            <StyledLeftAlignedContainer xs={8} item>
              {subdomainType === "" || subdomainType === "myauctionsdemo.in" ? (
                <HeaderMenu menuData={MenuData} />
              ) : (
                <HeaderMenu menuData={SubDoaminMenuData} />
              )}
              {/* {subdomainType === "" || subdomainType === "myauctionsdemo.in" ? (
                <HeaderMenu
                  menuData={MenuData.filter((item: any) =>
                    item.tab === "auction" ? auctionList.length > 0 : true
                  )}
                />
              ) : (
                <HeaderMenu
                  menuData={SubDoaminMenuData.filter((item: any) =>
                    item.tab === "auction" ? auctionList.length > 0 : true
                  )}
                />
              )} */}
            </StyledLeftAlignedContainer>
            <StyledRightAlignedContainer
              xs={1}
              item
            ></StyledRightAlignedContainer>
            <StyledRightAlignedContainer xs={2} item>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                }}
              >
                <LanguageSelector />
                <NotificationToggle />
                <ProfileMenu />
              </div>
            </StyledRightAlignedContainer>
            <HiddenButton id="hiddenButton"></HiddenButton>
          </Grid>
        </Container>
      </HeaderContainer>
    </DialogProvider>
  );
};

export const MobileHeader = ({ isZipangDomain, isGlowstar }: any) => {
  const [open, setState] = useState(false);
  const [auctionList, setAuctionList] = useState([]);
  useEffect(() => {
    console.log("MobileHeader Fetch Auction", window.location.pathname);
 const queryParams = new URLSearchParams(window.location.search);
  if(queryParams.get("source") === 'admin'){ 
    //Admin Preview Link hitted
    return;
  }
    const fetchAuctions = async () => {
      try {
        const auctionlist = await auctions();
        if (!auctionlist?.results || auctionlist.results.length === 0) {
          return;
        }
        setAuctionList(auctionlist.results);
      } catch (error) {
        console.error("Failed to fetch auction list", error);
      }
    };

    fetchAuctions();
  }, []);
  //function that is being called every time the drawer should open or close, the keys tab and shift are excluded so the user can focus between the elements with the keys
  const toggleDrawer = (open: any) => (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    //changes the function state according to the value of open
    setState(open);
  };

  let subdomainType = localStorage.getItem("subDomain");

  return (
    <HeaderContainer
      className="headerContainer"
      style={{ position: "fixed", height: "50px" }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ position: "absolute", width: "100%" }}
      >
        <StyledLogoBackground onClick={toggleDrawer(true)}>
          {isZipangDomain ? (
            <StyledLogo src="/images/zipangLogo.png" alt="zipangLogo#1" />
          ) : (
            <>
              {isGlowstar ? (
                <StyledLogo
                  src="https://ds29nc3ljdjce.cloudfront.net/icon.png"
                  alt="glowstart url"
                />
              ) : (
                <Logo />
              )}
            </>
          )}
        </StyledLogoBackground>
        <div
          style={{
            display: "flex",
            gap: "15px",
            alignItems: "center",
            marginRight: "20px",
          }}
        >
          <LanguageSelector />
          <NotificationToggle />
          <ProfileMenu />
        </div>
      </Grid>
      <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            p: 2,
            height: 1,
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <IconButton sx={{ mb: 1 }}>
              <CloseIcon onClick={toggleDrawer(false)} />
            </IconButton>
            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems: "center",
              }}
            ></div>
          </div>
          {subdomainType === "" || subdomainType === "myauctionsdemo.in" ? (
            <Box sx={{ mb: 1, alignItems: "center" }}>
              {MenuData.map((item: any, index: any) => (
                <MobileMenus item={item} key={index} />
              ))}
            </Box>
          ) : (
            <Box sx={{ mb: 1, alignItems: "center" }}>
              {SubDoaminMenuData.map((item: any, index: any) => (
                <MobileMenus item={item} key={index} />
              ))}
            </Box>
          )}
        </Box>
      </Drawer>
    </HeaderContainer>
  );
};

// header
const Header = () => {
  let isZipangDomain = localStorage.getItem("isZipangDomain");
  let isGlowstar = localStorage.getItem("isGlowstarDomain");
  if (isZipangDomain !== null) {
    isZipangDomain = JSON.parse(isZipangDomain);
  }
  if (isGlowstar !== null) {
    isGlowstar = JSON.parse(isGlowstar);
  }
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));
  return isMobile ? (
    <MobileHeader isZipangDomain={isZipangDomain} isGlowstar={isGlowstar} />
  ) : (
    <WebHeader isZipangDomain={isZipangDomain} isGlowstar={isGlowstar} />
  );
};

export default Header;
